module.exports = __webpack_public_path__ + "img/amex.9dc241ae.png";